import React, { useState, useEffect } from 'react';
import {RxCheckCircled} from 'react-icons/rx';
import {HiExternalLink} from 'react-icons/hi';
import {HiArrowNarrowRight} from 'react-icons/hi';
import {BsFillSendFill} from 'react-icons/bs';
import {FiPhoneCall} from 'react-icons/fi';
import {CiFaceSmile} from 'react-icons/ci';
import {MdSupportAgent} from 'react-icons/md';
import {MdSecurity} from 'react-icons/md';
import {AiFillFormatPainter} from 'react-icons/ai';
import {BsShieldShaded} from 'react-icons/bs';
import {IoMegaphoneOutline} from 'react-icons/io5';
import {HiOutlineArrowRight} from 'react-icons/hi';
import {BiUser} from 'react-icons/bi';
import {MdWifiCalling} from 'react-icons/md';
import {RiBuilding2Line} from 'react-icons/ri';
import {AiOutlineMail} from 'react-icons/ai';
import { NavLink } from 'react-router-dom'
import Sed from '../../img/Hed.png';
import img2 from '../../img/am1.jpg';
import img3 from '../../img/am2.png';
import img4 from '../../img/am3.png';
import img5 from '../../img/am4.jpeg';
import img6 from '../../img/img4.png';
import img7 from '../../img/img2.png';
import img10 from '../../img/01.jpg';
import cimg from '../../img/Rect15.png';
import cimg2 from '../../img/Rect 16.png';
import cimg3 from '../../img/Rec 17.png';
import cimg10 from '../../img/Re 20.png';
import Cdot from '../../img/cog.png';
import Cdot2 from '../../img/gn.png';
import Cdot3 from '../../img/Group 4.png';
import Cdot10 from '../../img/ass.png';
import Cdot22 from '../../img/Lib.png';
import hed from '../../img/intelli X Logo.png';
import s1 from '../../img/s1.png';
import s2 from '../../img/s2 (2).png';
import s3 from '../../img/s3.png';
import s4 from '../../img/s4.png';
import s5 from '../../img/s5.png';
import s6 from '../../img/s6.png';
import vec from '../../img/Vect.png';
import Model from '../Model/Model';
import Frem from '../../img/Frame 15.png';
import fremm from '../../img/HMS.png';
import fremm3 from '../../img/check1.png';
import fremm2 from '../../img/check.png';
import Age from '../../img/G370.png';
import Footer from '../Footer/Footer';
import Carousel from 'better-react-carousel';
import './Home.css';   
import One from './One';
import Two from './Two';
import Three from './Three';  
import { Link } from 'react-scroll';
import Header from '../Header/Header';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';





const Home = () => { 
  
   const [count, setcount] = useState()
   
   const [show, setShow] = useState(false);

   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);



   useEffect(() => {
    handleShow();
    setcount('Abc');
     
   }, [])
   



  return (
    <>

      <Header/>

  <section style={{backgroundColor:'#ECF0F9', }}>
    <div className='container'  >
    <div className='row'>
      <div className='col-lg-6 col-md-6 col-sm-12 demo order-last order-md-first 
      ' style={{paddingTop:'10rem'}}>
      
        
        <h2>Say Hii, <b> To World’s First AI <br></br>
        Powered Inclusive Solution </b> for <br></br> 
        your Educational Institute</h2> 

        <div className='row mt-4'>
        <div className='col-lg-6 col-sm-12'>
        
        
        <div  style={{backgroundColor:'#fff', borderRadius:'8px'}}>
          <p className='py-2  '> <RxCheckCircled className='mx-2' style={{color:'#0CCE7D',
           fontWeight:'900', fontSize:'20px'}}/>  Automatic Fees Collection system</p>
        </div>
        
        </div>
        </div>

        <div className='row'>
        
        <div className='col-lg-3 col-sm-12'>
        <div  style={{backgroundColor:'#fff', borderRadius:'8px'}}>
        <p className='py-2 '> <RxCheckCircled className='mx-2' style={{color:'#0CCE7D',
         fontWeight:'900', fontSize:'20px'}}/>  Free To Use</p>
      </div> 
        </div>

        <div className='col-lg-6 col-sm-12'>
        <div  style={{backgroundColor:'#fff', borderRadius:'8px'}}>
        <p className='py-2  '> <RxCheckCircled className='mx-2' style={{color:'#0CCE7D',
         fontWeight:'900', fontSize:'20px'}}/>  Real Time AI Powered Analytics</p>
      </div> 
        </div>



        </div>

        <div className='row'>
        
        <div className='col-lg-5 col-sm-12'>
        <div  style={{backgroundColor:'#fff', borderRadius:'8px'}}>
        <p className='py-2  '> <RxCheckCircled className='mx-2' style={{color:'#0CCE7D',
         fontWeight:'900', fontSize:'20px'}}/> HR & Payroll Automation</p>
      </div> 
        </div>

        <div className='col-lg-6 col-sm-12'>
        <div  style={{backgroundColor:'#fff', borderRadius:'8px'}}>
        <p className='py-2  '> <RxCheckCircled className='mx-2' style={{color:'#0CCE7D',
         fontWeight:'900', fontSize:'20px'}}/>  Automatic Attendance System</p>
      </div> 
        </div> 
        </div>

        <p style={{color:'#63749B'}}>and much more...</p> 

        <div className='row mb-4'  >

        <div className='col-lg-4 col-md-6 col-sm-12'>
        <Link to="Solution" smooth={true} duration = {100}> <button className='btn ss3' style={{ backgroundColor:'#fff', color:"#000", border:'1px solid #000',
        padding:'10px 12px', width:'100%'}}>View All Features</button></Link>
        </div>
         
        <div className='col-lg-4 col-md-6 col-sm-12'>

        <button className='btn  ss4'  data-bs-toggle="modal" data-bs-target="#exampleModal" style={{ backgroundColor:'#000', color:"#fff", border:'1px solid #000', padding:'10px 40px',width:'100%'}}>Get Started  </button>
           
        </div> 
        </div> 
      </div> 

    <div className='col-lg-6 col-md-6 col-sm-12 mt-5 SEDD 
    order-first order-md-last'>
          <img src={Sed} alt='#' className=' ft p-5 ' style={{width:'100%'}}/>
      </div>
    </div>
    </div>
    </section>


    <section>
      <div className='container my-5'>
       <div className='row'>
         <div className='col-lg-12 col-md-12 col-sm-12'>
            <h3 className='text-center' style={{color:'#343434'}}>Our Clients</h3> 
         </div>
       </div>
      </div>
    </section>


    <section>
    
    <div className='container'>
     <div className='row'>
          
     <div className='col-lg-12 col-sm-12 col-md-12'>
    
     <Carousel cols={4} rows={1} gap={10} loop autoplay={2000}>
     <Carousel.Item>
     <div style={{display:'flex', justifyContent:'center'}}>
     <img src={img2} alt='image'  style={{width:'200px'}}/>
     </div>
     </Carousel.Item> 

     <Carousel.Item>
     <div className='mt-5 pt-3' style={{display:'flex', justifyContent:'center'}}>
     <img src={img3} alt='image'   style={{width:'200px'}}/> 
     </div>
     </Carousel.Item>


     <Carousel.Item>
     <div className='mt-3' style={{display:'flex', justifyContent:'center'}}>
     <img src={img4} alt='image' style={{width:'150px'}} />
     </div>
     </Carousel.Item>


     <Carousel.Item>
     <div className='mt-3' style={{display:'flex', justifyContent:'center'}}>
     <img src={img5} alt='image' style={{width:'150px'}} />
     </div>
     </Carousel.Item>

      <Carousel.Item>
     <div style={{display:'flex', justifyContent:'center'}}>
     <img src={img2} alt='image'  style={{width:'200px'}}/>
     </div>
     </Carousel.Item> 

     <Carousel.Item>
     <div className='mt-5 pt-3' style={{display:'flex', justifyContent:'center'}}>
     <img src={img3} alt='image'   style={{width:'200px'}}/> 
     </div>
     </Carousel.Item>

 


     <Carousel.Item>
     <div className='mt-3' style={{display:'flex', justifyContent:'center'}}>
     <img src={img5} alt='image' style={{width:'150px'}} />
     </div>
     </Carousel.Item>

     <Carousel.Item>
     <div className='mt-3' style={{display:'flex', justifyContent:'center'}}>
     <img src={img10} alt='image' style={{width:'150px'}} />
     </div>
     </Carousel.Item>

     
     {/* ... */}
   </Carousel> 
     </div> 



      <div className='col-lg-2 col-md-6 col-sm-12'> 
      
      </div>
      <div className='col-lg-2 col-md-6 col-sm-12'> 
      
      </div>
      <div className='col-lg-2 col-md-6 col-sm-12'> 
    
      </div>
      <div className='col-lg-2 col-md-6 col-sm-12'> 
       
      </div>
      <div className='col-lg-2 col-md-6 col-sm-12'> 
  
      </div>
      <div className='col-lg-2 col-md-6 col-sm-12'> 
   
      </div>


         <div className='my-4'>
           <h5 style={{color:'#6a6a6a', textAlign:'center'}}>+2000 Other </h5> 
         </div>
     </div>
    </div>
    </section>

    <section>
       <div className='container py-4' style={{backgroundColor:'#ECF0F9', borderRadius:'10px  '}}>
        <div className='row'>
          <div className='col-lg-12 col-sm-12'>
             
          <h2 className='text-center pt-3'>Our Products</h2>
          <p className='text-center pt-2' style={{color:'#343434'}}>We offer a range of SAAS products which helps you to automate every aspect <br></br>of your Educational Business      </p>
              
          
               
          <div className='row mt-5'>
           <div className='col-lg-10 m-auto'>

           <div className='row'>
            
           <div className='col-lg-4 col-md-6 col-sm-12 mt-4'>
           <NavLink to="/CogniCampuX" style={{textDecoration:"none"}}>
           <div class="card" style={{width:'100%', border:'none', borderRadius:'15px',}} >
           <img src={cimg}  alt="img"  style={{width:'100%'}} />
           <div class="card-body">
             <p class="card-title text-center pt-3" style={{color:'#6a6a6a'}}>Automate Your Institutional<br></br> Management with</p>
               <img src={Cdot} alt='img' className='px-5'  style={{width:'100%'}} />

               <div className='mt-2' style={{display:'flex', justifyContent:'center'}}>
                 <button className='btn' style={{color:'#3572FA'}}>Know More <HiExternalLink 
                  style={{color:'#3572FA', fontSize:'18px'}} /> </button>
               </div>
           </div>
         </div>
         </NavLink>
 
           </div>


           <div className='col-lg-4 col-md-6 col-sm-12 mt-4'>
           <NavLink to='Product' style={{textDecoration:'none'}}>
           <div class="card" style={{width:'100%', border:'none', borderRadius:'15px',}} >
           <img src={cimg2}  alt="img"  style={{width:'100%'}} />
           <div class="card-body">
             <p class="card-title text-center pt-3" style={{color:'#6a6a6a'}}>Transform to Digital Education <br></br>with 100% Automation</p>
             <div style={{display:'flex', justifyContent:'center'}}>
               <img src={Cdot2} alt='img' className='px-5'  style={{width:'70%'}} />
               </div>
               <div className='mt-2' style={{display:'flex', justifyContent:'center'}}>
                 <button className='btn' style={{color:'#3572FA'}}>Know More <HiExternalLink 
                  style={{color:'#3572FA', fontSize:'18px'}} /> </button>
               </div>
           </div>
         </div>
         </NavLink>
 
           </div>
                 
           <div className='col-lg-4 col-md-6 col-sm-12 mt-4'>
           <NavLink to='Hms' style={{textDecoration:'none'}}>
           <div class="card" style={{width:'100%', border:'none', borderRadius:'15px',}} >
           <img src={cimg3}  alt="img"  style={{width:'100%'}} />
           <div class="card-body">
             <p class="card-title text-center pt-3" style={{color:'#6a6a6a'}}>Automate Your PG/Hostel within <br/> Seconds with</p>
             <div className='my-3' style={{display:'flex', justifyContent:'center'}}>
               <img src={Cdot3} alt='img' className='px-5'  style={{width:'100%'}} />
               </div>
               <div className='mt-2' style={{display:'flex', justifyContent:'center'}}>
                 <button className='btn' style={{color:'#3572FA'}}>Know More <HiExternalLink 
                  style={{color:'#3572FA', fontSize:'18px'}} /> </button>
               </div>
           </div>
         </div>
         </NavLink>
 
           </div> 
           </div> 
           </div>
          </div> 



          </div>
        </div>
       </div>
    </section>
            

    <section>
     <div className='container'>
      <div className='row'>
       <div className='col-lg-12 col-md-12 col-sm-12'>
         
       <h3  className='text-center mt-4'>Upcoming Products</h3>

       <div style={{display:'flex', justifyContent:'center'}}>
       <p  className='text-center mt-4 Research' style={{width:'50%'}}>Our Research and Development Team Continuously work in order to deliver the <br></br> latest and most required automation products in order to keep your business running Smoothly</p> 
       </div>

             
       <div className='row mt-5'>
       <div className='col-lg-7 m-auto'>

       <div className='row'>
        
       <div className='col-lg-5 col-md-6 col-sm-12 mt-3'>
       <div class="card" style={{width:'100%', border:'none', borderRadius:'15px',}} >
       <img src={cimg10}  alt="img"  style={{width:'100%'}} />
       <div class="card-body">
         <p class="card-title text-center pt-3" style={{color:'#6a6a6a'}}>Automate Your Institutional<br></br> Management with</p>
           <img src={Cdot10} alt='img' className='px-5'  style={{width:'100%'}} />

           <div className='mt-2' style={{display:'flex', justifyContent:'center'}}>
             <button className='btn' style={{color:'#909090'}}>Coming Soon...   </button>
           </div>
       </div>
     </div>

       </div>


       <div className='col-lg-5 col-md-6 col-sm-12 mt-3'>
       <div class="card" style={{width:'100%', border:'none', borderRadius:'15px',}} >
       <img src={cimg2}  alt="img"  style={{width:'100%'}} />
       <div class="card-body">
         <p class="card-title text-center pt-3" style={{color:'#6a6a6a'}}>Library Management Made <br></br>Super Easy with</p>
         <div style={{display:'flex', justifyContent:'center'}}>
           <img src={Cdot22} alt='img' className='px-5'  style={{width:'90%'}} />
           </div>
           <div className='mt-2' style={{display:'flex', justifyContent:'center'}}>
           <button className='btn' style={{color:'#909090'}}>Coming Soon...   </button>
         </div>
       </div>
     </div>

       </div> 

       </div>


       </div>
      </div>

       </div>
      </div>
     </div>
    </section>


    <section className='mt-4'>
      <div className='container mt-3'>
       <div className='row'>
        <div className='col-lg-6 col-md-6 col-sm-12 mt-4'>
           
        <div  style={{display:'flex', }}>
        <img src={hed} alt='#' style={{width:'200px', height:'auto'}} />

         <HiArrowNarrowRight className='mt-4 ms-4' style={{fontSize:'40px'}}/>

        </div>
        </div>

        <div className='col-lg-4 col-md-6 col-sm-12 mt-2'> 
        </div>


        <div className='col-lg-2 col-md-6 col-sm-12 mt-2'> 
        
        <div className='Get'>
          <button type='btn' className='mm1'  data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#000', color:'#fff', padding:'8px 20px', borderRadius:'10px', width:'auto'}}> <BsFillSendFill className='me-2'/>  Get Started</button><br></br><br></br>
          
          
          <button type='btn' className='mm2' data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#177FFC', color:'#fff', padding:'8px 30px', borderRadius:'10px', width:'auto', border:'none'}}> <FiPhoneCall className='me-2'/> 
           Talk to Us</button>
        </div>

        </div>
       </div>
      </div>
    </section>



    <section  id='Solution' > 
    <div className='container mt-5'>
      <div className='row'>
       <div className='col-lg-4 col-md-6 col-sm-12 mt-3 '>
               
       
       <div class="card p-3"  style={{border:'none'}}>
       <div style={{display:'flex', justifyContent:'center',borderBottom:'1px solid #b0b0b0'  }}>
       <img src={s1}  alt="..." style={{width:'50%',}} />
 
       </div>
        <div class="card-body">
          <h5 class="card-title text-center">All In One Solution</h5>
          <p class="card-text text-center" style={{fontSize:'14px ', color:'#6a6a6a'}}>Now, no need to have multiple Service Providers for your various Departments/Roles. Easily manage Everything at one Place & Reduce your Operational Cost.</p>
          
        </div>
</div>
          


       </div>


       <div className='col-lg-4 col-md-6 col-sm-12 mt-3'>
               
       
       <div class="card p-3"  style={{border:'none'}}>
       <div style={{display:'flex', justifyContent:'center',borderBottom:'1px solid #b0b0b0'  }}>
       <img src={s2}  alt="..." style={{width:'64%',}} />
 
       </div>
  <div class="card-body">
    <h5 class="card-title text-center">Free to Use</h5>
    <p class="card-text text-center" style={{fontSize:'14px ', color:'#6a6a6a'}}>Our platform is Free to Use for Everyone who has a capacity of upto 50 Student, with absolutely 0 cost infrastructure. </p>
    
  </div>
</div>
          


       </div>

       <div className='col-lg-4 col-md-6 col-sm-12 mt-3' >
               
       
       <div class="card p-3"  style={{border:'none'}}>
       <div style={{display:'flex', justifyContent:'center',borderBottom:'1px solid #b0b0b0'  }}>
       <img src={s3}  alt="..." style={{width:'50%',}} />
 
       </div>
  <div class="card-body">
    <h5 class="card-title text-center">Hi-End AI Structure</h5>
    <p class="card-text text-center" style={{fontSize:'14px ', color:'#6a6a6a'}}>We use best in Class Artificial Intelligence algorithm to back our Analytics and Dashboard, which helps you to make more précised and informative Decision </p>
    
  </div>
</div>
          


       </div>
      </div>
     </div> 
    </section>

    <section>
    <div className='container mt-5'>
     <div className='row'>
      <div className='col-lg-4 col-md-6 col-sm-12 mt-3'>        
      
      <div class="card p-3"  style={{border:'none'}}>
      <div style={{display:'flex', justifyContent:'center',borderBottom:'1px solid #b0b0b0'  }}>
      <img src={s4}  alt="..." style={{width:'65%',}} />

      </div>
 <div class="card-body">
   <h5 class="card-title text-center">In-Built Payments System</h5>
   <p class="card-text text-center" style={{fontSize:'14px ', color:'#6a6a6a'}}>Don’t Worry about getting your accounts done manually, just use our in built payments system to make Payouts or to Collect Money, our Intelligent AI Algorithm will take care of everything else</p>
   
 </div>
</div>
         


      </div>


      <div className='col-lg-4 col-md-6 col-sm-12 mt-3'>
              
      
      <div class="card p-3"  style={{border:'none'}}>
      <div style={{display:'flex', justifyContent:'center',borderBottom:'1px solid #b0b0b0'  }}>
      <img src={s5}  alt="..." style={{width:'51%',}} />

      </div>
    <div class="card-body">
   <h5 class="card-title text-center">Web Based System</h5>
   <p class="card-text text-center" style={{fontSize:'14px ', color:'#6a6a6a'}}>No need to download ugly software in your system, just login to your account using any browser and you are good to go. anywhere, anytime. </p>
   
 </div>
</div>
         


      </div>

      <div className='col-lg-4 col-md-6 col-sm-12 mt-3'>
              
      
      <div class="card p-3"  style={{border:'none'}}>
      <div style={{display:'flex', justifyContent:'center',borderBottom:'1px solid #b0b0b0'  }}>
      <img src={s6}  alt="..." style={{width:'90%',}} />

      </div>
 <div class="card-body">
   <h5 class="card-title text-center">100% Data Privacy</h5>
   <p class="card-text text-center" style={{fontSize:'14px ', color:'#6a6a6a'}}>Our Strong cybersecurity practices and Data Protection policies makes out platform the first choice for any Education business.</p>
   
 </div>
</div>
         


      </div>
     </div>
    </div>
   </section>




   <section className='mt-5'>
      <div className='container  '>
       <div className='row'>
        <div className='col-lg-6 col-md-6 col-sm-12 mt-4'>
           <div>
            <h2>Other Features of</h2>
           </div>   
        <div  style={{display:'flex', }}>
        <img src={hed} alt='#' style={{width:'200px', height:'auto'}} />
         <HiArrowNarrowRight className='mt-4 ms-4' style={{fontSize:'40px'}}/>
        </div>
        </div>

        <div className='col-lg-4 col-md-6 col-sm-12 mt-2'> 
        </div>


        <div className='col-lg-2 col-md-6 col-sm-12 mt-2'> 
        
        <div className='Get'>

          <button type='btn' className='mm1'  data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#000', color:'#fff', padding:'8px 20px', borderRadius:'10px', width:'auto'}}> <BsFillSendFill className='me-2'/>  Get Started</button><br></br><br></br>
          <button type='btn' className='mm1' data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#177FFC', color:'#fff', padding:'10px 30px', borderRadius:'10px',padding:'10px 30px', width:'auto', border:'none'}}> <FiPhoneCall className='me-2'/>  Talk to Us</button>

        </div>
        </div>
       </div>
      </div>
    </section>


    <section>
     <div className='container mt-5'>
      <div className='row'>
       <div className='col-lg-4 col-md-6 col-sm-12'> 
               
       <div class="card mb-3" style={{borderRadius:'10px', }} >
     <div class="row g-0">
       <div class="col-md-2">
        <div style={{display:'flex', justifyContent:'center'}}>
        <CiFaceSmile className='mt-2' style={{color:'#0AC677', fontSize:'50px', backgroundColor:'#DCFFF0', borderRadius:'50%', padding:'5px'}}/>
       </div>
     </div>
     <div class="col-md-10">
      <div class="card-body">
        <h5 class="card-title">Beautiful User Interface</h5>
        <p class="card-text" style={{color:'#909090'}}>Say goodbye to ugly looking interfaces, get a completely changed and mesmerizing look of the system which is designed to function seamlessly and look Aesthetically pleasing    </p>
      
      </div>
    </div>
  </div>
</div>



       </div>
       <div className='col-lg-4 col-md-6 col-sm-12'>
       
               
       <div class="card mb-3" style={{borderRadius:'10px'}} >
  <div class="row g-0">
    <div class="col-md-2">
     <div style={{display:'flex', justifyContent:'center',}}> 
     <img src={vec} alt='img' className='mt-3' />
     </div>
    </div>
    <div class="col-md-10">
      <div class="card-body">
        <h5 class="card-title">Easy Onboarding</h5>
        <p class="card-text" style={{color:'#909090'}}>Now implementing our best in class solution is just 3 Clicks Away, start your Journey to scale within 5 minutes. No complicated agreements or formalities required</p>
      
      </div>
    </div>
  </div>
</div>



       </div>


       <div className='col-lg-4 col-md-6 col-sm-12'> 
       <div class="card mb-3" style={{borderRadius:'10px'}} >
  <div class="row g-0">
    <div class="col-md-2">
     <div style={{display:'flex', justifyContent:'center'}}>
       <MdSupportAgent className='mt-2' style={{color:'#F09B5B', fontSize:'50px', backgroundColor:'#FFEBDC', borderRadius:'50%', padding:'5px'}}/>
     </div>
    </div>
    <div class="col-md-10">
      <div class="card-body">
        <h5 class="card-title">24*7 Technical Support</h5>
        <p class="card-text" style={{color:'#909090'}}>Don’t get worried about any type of technical hurdle coming in your way, just give us a ring on our Toll Free number : 1800-1111-222-555 and we will assist you.</p>
      
      </div>
    </div>
  </div>
</div>



       </div>
      </div>
     </div>
    </section>

    <section>
     <div className='container mt-4'>
      <div className='row'>
       <div className='col-lg-4 col-md-6 col-sm-12'>
       
               
       <div class="card mb-3" style={{borderRadius:'10px'}} >
  <div class="row g-0">
    <div class="col-md-2">
     <div style={{display:'flex', justifyContent:'center'}}>
       <MdSecurity className='mt-2' style={{color:'#0AC677', fontSize:'50px', backgroundColor:'#DCFFF0', borderRadius:'50%', padding:'5px'}}/>
     </div>
    </div>
    <div class="col-md-10">
      <div class="card-body">
        <h5 class="card-title">High Level Cyber Security</h5>
        <p class="card-text" style={{color:'#909090'}}>We implement best in class coding and deployment practices in order to make our systems more secured and less vulnerable, just sit back and chill, our Bulldog is on Duty. </p>
      
      </div>
    </div>
  </div>
</div>



       </div>
       <div className='col-lg-4 col-md-6 col-sm-12'>
       
               
       <div class="card mb-3" style={{borderRadius:'10px'}} >
  <div class="row g-0">
    <div class="col-md-2">
    <div style={{display:'flex', justifyContent:'center'}}>
    <AiFillFormatPainter className='mt-2' style={{color:'#3E30DE', fontSize:'50px', backgroundColor:'#DFDCFF', borderRadius:'50%', padding:'5px'}}/>
  </div>
    </div>
    <div class="col-md-10">
      <div class="card-body mb-4">
        <h5 class="card-title">White labelling</h5>
        <p class="card-text" style={{color:'#909090'}}>Now deliver our high end Services directly to your Staff/Students with your own logo, we make sure to give you a premium experience at minimum cost.</p>
      
      </div>
    </div>
  </div>
</div>



       </div>


       <div className='col-lg-4 col-md-6 col-sm-12'>
       
               
       <div class="card mb-3" style={{borderRadius:'10px'}} >
      <div class="row g-0">
      <div class="col-md-2">
      <div style={{display:'flex', justifyContent:'center'}}>
       <BsShieldShaded className='mt-2' style={{color:'#F10066', fontSize:'50px', backgroundColor:'#FFDCE3', borderRadius:'50%', padding:'5px'}}/>
      </div>
      </div>
      <div class="col-md-10">
      <div class="card-body">
        <h5 class="card-title">Physical/Digital Theft Protection</h5>
        <p class="card-text" style={{color:'#909090'}}>Our system incorporates inter communication between the platforms which makes sure to keep all your assets guarded without any additional hardware. </p>
      
      </div>
    </div>
  </div>
</div>



       </div>
      </div>
     </div>
    </section>




    <section>
      <div className='container mt-5'>
       <div className='row'>
        <div className='col-lg-12 col-md-12 col-sm-12'>
           
        <h3 className='text-center'>Product Overview</h3>

        <p className='text-center pt-2' style={{color:'#343434'}}>Get a taste of what our product looks and feel and have in depth insights about<br/>  how you can implement Intelli X 360 in your business.  </p> 

        </div>
       </div>
      </div>
    </section>



    <section>
     <div className='container'>
     <div className='row'>
      <div className='col-lg-6 col-sm-12 m-auto'>
      <div className='row'>

      <span className='col-lg-4 col-md-4 col-sm-4 col-4 mt-3' onClick={()=>{setcount('Abc')}}> 
      <img src={fremm2} alt='#' style={{width:'70%', padding:'12px', borderRadius:'8px',
         backgroundColor:count==="Abc"?"#f1f1f1":" "  }}/>
      </span>

      <span className='col-lg-4 col-md-4 col-sm-4 col-4 mt-3' onClick={()=>{setcount('Abc2')}}> 
      <img src={fremm3} alt='#' style={{width:'80%',padding:'12px', borderRadius:'8px',
       backgroundColor:count==="Abc2"?"#f1f1f1":""}}/>
      </span>

      <span className='col-lg-4 col-md-4 col-sm-4 col-4 mt-4' onClick={()=>{setcount('Abc3')}}> 
      <img src={fremm} alt='#' className='py-3' style={{width:'80%',padding:'12px', borderRadius:'8px',
      backgroundColor:count==="Abc3"?"#f1f1f1":""}}/>
      </span>
      
      </div>
      </div>
     </div>





      <div className='row my-5'>
       <div className='col-lg-12 col-md-12 col-sm-12'> 
       {
        count==="Abc"?<> <One/> </>:<></>
       }
       {
        count==="Abc2"?<> <Two/> </>:<></>
       }
       {
        count==="Abc3"?<> <Three/> </>:<></>
       }
       </div>
      </div> 
     </div>
    </section>


    <section>
     <div className='container p-3' style={{backgroundColor:'#FB1C1C', borderRadius:'8px'}}>
      <div className='row'>
      
      <div className='col-lg-1 col-md-6 col-sm-12'>
      </div>


      <div className='col-lg-2 col-md-6 col-sm-12'> 
       <p className='  text-white text-center'> <IoMegaphoneOutline className='me-2'/>  Announcement</p>

       <h2  className=' text-center  text-white'>We are Not <br/>
       an ERP!!</h2> 
       </div>


        


       <div className='col-lg-6 '>
       </div>

       <div className='col-lg-2 col-md-6 col-sm-12'>

       <div className='mt-5 d-flex justify-content-center'>
         <button type='btn ' data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#fff', border:'none', borderRadius:'8px', padding:'10px 20px'}}>Know More</button>
       </div>

       </div>


      </div>
     </div>
    </section>

     
   
 
    
    <section className='mt-4'>
     <Footer/>
    </section> 


    <section>
     <div className='container'>
     <div className='row'>
      <div className='col-lg-12 col-sm-12'> 
 
   
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"  style={{backdropFilter:'blur(5px)'}}>
        <div class="modal-dialog modal-dialog-centered modal-lg" >
          <div class="modal-content"  style={{paddingTop:'0%'}}>
             

          <div class="modal-body">

                <Model/>
          </div>
            
          </div>
        </div>
      </div>


      </div>
     </div>
     </div>
    </section> 





    <Modal show={show} onHide={handleClose} centered animation={false} size="lg"
     style={{backdropFilter:'blur(2px)'}}>
    <Modal.Header closeButton style={{border:'none'}}> 
    </Modal.Header>
    <Modal.Body>
      


    <div> 
       

          <div className='row'>  
           <div className='col-lg-6 col-sm-12 mt-2'>
           <img src={hed} alt='#' style={{width:'50%'}}/>

           <div className='ms-1 mt-2'>
            <h3 style={{color:'#343434 '}}>Get In touch  <HiOutlineArrowRight/></h3>
           </div>

                    
           <form className='form'>
           
           <div class="input-group mt-4 mt-3">
           <span class="input-group-text" id="basic-addon1"
            style={{backgroundColor:'transparent',border:'1px solid #EDEDED', borderRadius:'8px 0px 0px 8px'}}><BiUser style={{fontSize:'22px'}}/></span>
           <input type="text" class="form-control py-2" placeholder="Enter your name" aria-label="Username" aria-describedby="basic-addon1" required style={{border:'1px solid #EDEDED', borderLeft:'none',borderRadius:'0px 8px 8px 0px',boxShadow:'none'}}/>
         </div>  


         <div class="input-group mt-4 mt-3">
         <span class="input-group-text" id="basic-addon1"
          style={{backgroundColor:'transparent',border:'1px solid #EDEDED', borderRadius:'8px 0px 0px 8px'}}><RiBuilding2Line style={{fontSize:'22px'}}/></span>
         <input type="text" class="form-control py-2" placeholder="Enter name of your institution" aria-label="Username" aria-describedby="basic-addon1 " required style={{border:'1px solid #EDEDED', borderLeft:'none',borderRadius:'0px 8px 8px 0px',boxShadow:'none'}}/>
       </div>



         <div class="input-group mt-4 mt-3">
         <span class="input-group-text" id="basic-addon1"
          style={{backgroundColor:'transparent',border:'1px solid #EDEDED', borderRadius:'8px 0px 0px 8px'}}><MdWifiCalling style={{fontSize:'22px'}}/></span>
         <input type="number" class="form-control py-2" placeholder="Enter your contact number" aria-label="Username" aria-describedby="basic-addon1" required style={{border:'1px solid #EDEDED', borderLeft:'none',borderRadius:'0px 8px 8px 0px',boxShadow:'none'}}/>
       </div>



         <div class="input-group mt-4 mt-3">
         <span class="input-group-text" id="basic-addon1"
          style={{backgroundColor:'transparent',border:'1px solid #EDEDED', borderRadius:'8px 0px 0px 8px'}}><AiOutlineMail style={{fontSize:'22px'}}/></span>
         <input type="email" class="form-control py-2" placeholder="Enter your email address" aria-label="Username" aria-describedby="basic-addon1" required style={{border:'1px solid #EDEDED', borderLeft:'none',borderRadius:'0px 8px 8px 0px',boxShadow:'none'}}/>
       </div>



       <div className='mt-5'>
        <button type='Submit' style={{backgroundColor:'#3572FA',color:'#fff', borderRadius:'8px ', padding:'10px 12px', border:'none', width:'100%'}}>Submit</button>
       </div>
         
           
           </form> 

           </div>


           <div className='col-lg-6 col-sm-12 mt-2'>
         
           <img src={Age} className='gajju' alt='#' style={{width:'100%',height:'500px'}}/>
           
           </div>
          </div>
            
          </div> 




     <Modal/>
    </Modal.Body>
 
  </Modal>




     

    </>
  )
}

export default Home;
